import moment from 'moment'

const DATE_FMT = 'YYYY-MM-DD'
const TIME_FMT = 'HH:mm:ss'
const FULL_DT_FMT = [DATE_FMT, TIME_FMT].join(' ')

export default [
    /**
     * When autoStart is true
     * - Event must have startDateTime set 
     * - Must not fall after autoStopTime (if set)
     * 
     * @returns {Boolean} true if invalid
     */
    (function (value, data) {

        if (value === true) {

            // Only worry that the time is after now
            if (!!data.autoStop === false) {
                let preroll = data.preroll || 0
                let startDateTime = data.startDateTime

                let now = moment(moment(), FULL_DT_FMT)
                if (!moment.isMoment(startDateTime)) {
                    startDateTime = moment(startDateTime, FULL_DT_FMT)
                }

                // Must be after now + 10 minutes (including preroll)
                let final = startDateTime.subtract(preroll, 'minutes')
                let threshold = now.add(10, 'minutes').startOf('minute');
                return final.isSameOrAfter(threshold)
            } else {
                // If either stopDate/stopTime are not
                // provided return false
                if (
                    data.autoStop === true &&
                    (
                        !!data.stopDate === false ||
                        !!data.stopTime === false
                    )
                ) return false
                
                let { stopDate, stopTime } = data
                let autoStopTime = moment(
                    [
                        stopDate.format(DATE_FMT), 
                        stopTime.format(TIME_FMT)
                    ].join(' '),
                    FULL_DT_FMT
                )

                return !(
                    moment(data.startDateTime, FULL_DT_FMT)
                        .isAfter(autoStopTime)
                )
            }
        }

        return true
    })
]